<template>
    <div class="changelog" data-testid="changelog">
        <div class="row">
            <div class="col-xs-12">
                <h1>What's New</h1>
            </div>
        </div>
        <div v-if="error" class="row">
            <div class="col-xs-12">
                <div class="alert alert-danger">{{ error }}</div>
            </div>
        </div>
        <div class="row">
            <div class="col-xs-12">
                <p v-if="loading" data-testid="changelog-loading">Loading...</p>
                <p v-if="!loading && entries.length === 0 && !error" data-testid="changelog-empty">
                    No updates to show yet. Check back soon.
                </p>
                <article
                    v-for="entry in entries"
                    :key="entry.id"
                    class="changelog-entry"
                    data-testid="changelog-entry"
                >
                    <header>
                        <h3>
                            <a href="" @click.prevent="onViewEntry(entry.id)">{{ entry.title }}</a>
                        </h3>
                        <p class="text-muted">{{ formatDate(entry.published_at) }}</p>
                    </header>
                    <p class="changelog-entry-excerpt">{{ entry.excerpt }}</p>
                    <a href="" data-testid="changelog-read-more" @click.prevent="onViewEntry(entry.id)">
                        Read more &raquo;
                    </a>
                    <hr />
                </article>
            </div>
        </div>
        <div class="row">
            <div class="col-xs-12">
                <ActivityPagination
                    :current-page="pagination.current_page"
                    :last-page="pagination.last_page"
                    @pagechanged="changePage"
                />
            </div>
        </div>
    </div>
</template>

<script>
import ActivityPagination from '../../common/components/activity/ActivityPagination.vue';

export default {
    name: 'Changelog',
    components: { ActivityPagination },
    props: {
        entries: {
            type: Array,
            default: () => []
        },
        pagination: {
            type: Object,
            default: () => ({ current_page: 1, last_page: 1, total: 0 })
        },
        loading: {
            type: Boolean,
            default: false
        },
        error: {
            type: String,
            default: ''
        },
        onPageChange: {
            type: Function,
            required: true
        },
        onViewEntry: {
            type: Function,
            required: true
        }
    },
    methods: {
        formatDate(value) {
            if (!value) {
                return '';
            }
            return new Date(value).toLocaleDateString(undefined, {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
            });
        },
        changePage(page) {
            this.onPageChange(page);
        }
    }
};
</script>

<style scoped>
.changelog-entry header h3 {
    margin-bottom: 2px;
}

.changelog-entry .text-muted {
    margin-bottom: 12px;
}

.changelog-entry-excerpt {
    max-width: 720px;
}
</style>
